import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	menuTrigger: {
		id: 'backlog.card-list.sprints-menu.menu-trigger',
		defaultMessage: '{sprintName} actions',
		description: 'label for drop down menu button which open list with sprint actions',
	},
	editSprint: {
		id: 'backlog.card-list.sprints-menu.edit-sprint',
		defaultMessage: 'Edit sprint',
		description: '',
	},
	deleteSprint: {
		id: 'backlog.card-list.sprints-menu.delete-sprint',
		defaultMessage: 'Delete sprint',
		description: '',
	},
	moveSprintToTop: {
		id: 'backlog.card-list.sprints-menu.move-sprint-to-top',
		defaultMessage: 'Move sprint to top',
		description: 'Move the sprint to the top of all unscheduled sprints',
	},
	moveSprintUp: {
		id: 'backlog.card-list.sprints-menu.move-sprint-up',
		defaultMessage: 'Move sprint up',
		description: '',
	},
	moveSprintDown: {
		id: 'backlog.card-list.sprints-menu.move-sprint-down',
		defaultMessage: 'Move sprint down',
		description: '',
	},
	moveSprintToBottom: {
		id: 'backlog.card-list.sprints-menu.move-sprint-to-bottom',
		defaultMessage: 'Move sprint to bottom',
		description: 'Move the sprint to the bottom of all unscheduled sprints',
	},
	moreActionsTooltip: {
		id: 'backlog.card-list.sprints-menu.more-actions-tooltip',
		defaultMessage: 'More actions',
		description: 'Tooltip for the drop down menu button which opens a list with sprint actions',
	},
});
